/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Not_AvailableInputs */



/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Knp_Guide_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_not_available = /** @type {((inputs?: Knp_Guide_Not_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Not_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("N/A")
	if (locale === "de") return /** @type {LocalizedString} */ ("N / A")
	if (locale === "it") return /** @type {LocalizedString} */ ("N / A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Н/Д")
	if (locale === "es") return /** @type {LocalizedString} */ ("N / A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不适用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("該当なし")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लागू नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("N / D")
	return /** @type {LocalizedString} */ ("N/A")
});